import React from "react";
import styled from "styled-components";

import ThinButton from "./ThinButton";
import { flagred } from "../theme/Colors";

import background from "images/track_guides/video_placeholder";

const StyledPlaceholder = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: url(${background});
	background-size: contain;
`;

const Wrapper = styled.div`
	max-width: 500px;
	height: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 30px;
`;

/* const Info = styled.p`
	margin: 0;
	color: ${flagred};
	font-size: 1.75em;
	font-weight: bold;
	text-align: center;
	text-transform: uppercase;
`;

const StyledButton = styled(ThinButton)`
	font-size: 1.5em;
`; */

const VideoPlaceholder = () => (
	<StyledPlaceholder>
		<Wrapper>
			<p className="TGp2">Login or upgrade to unlock premium content</p>
			<a className="TGbtn" href="/users/sign_in">
				Login
			</a>
			<a className="TGbtn" href="/v3/quotes/start_quote">
				Upgrade
			</a>
		</Wrapper>
	</StyledPlaceholder>
);

export default VideoPlaceholder;
